module.exports = __webpack_public_path__ + "img/ep7-4.8cddad54.png";